import React, { createContext, useState, useEffect, useContext } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (token) localStorage.setItem('token', token);
    else localStorage.removeItem('token');

    if (user) localStorage.setItem('user', JSON.stringify(user));
    else localStorage.removeItem('user');
  }, [token, user]);

  const login = (newToken, newUser) => {
    setToken(newToken);
    setUser(newUser);
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    setShouldRedirect(true);   // <-- csak jelzés
  };

  const apiFetch = async (url, options = {}) => {
    const headers = {
      ...options.headers,
      Authorization: token ? `Bearer ${token}` : undefined,
    };

    const response = await fetch(url, { ...options, headers });

    if (response.status === 401) {
      logout();
      return null;
    }

    return response;
  };

  return (
    <AuthContext.Provider value={{
      token,
      user,
      login,
      logout,
      apiFetch,
      shouldRedirect,  // <-- hozzáadva
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
